// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'flag-wave';

export const Component = () => (
  <path d='M20.188 1.963h-6.37c0-.24-.096-.479-.288-.718a.976.976 0 0 0-.718-.288H5.963V11.78h6.849c0 .24.096.48.287.67a.976.976 0 0 0 .719.288h6.37c.43 0 .766-.143 1.053-.431.288-.287.432-.623.432-1.054V3.447c0-.431-.144-.767-.432-1.054a1.408 1.408 0 0 0-1.053-.431v.001Zm-7.375 0v8.813H6.921V1.963h5.89Zm7.853 1.485v7.807c0 .335-.143.526-.479.526h-6.369v-8.86h6.37c.335 0 .478.192.478.527ZM4.958.478v23.564c0 .335-.144.48-.48.48-.334 0-.478-.145-.478-.48V.48c0-.336.144-.48.479-.48.335 0 .479.144.479.479Z' />
);

export const viewBox = '0 0 25 25';
